<template>
    <client-menu :clients="clients">
        <div slot-scope="{canUpdateClient, clients, currentClient, isLoggedIn, onSelectClient, showClients}">
            <div v-if="(path !== '/dashboard' && path !== '/') || !showClients" class="flex items-center text-14 h-56 px-30 w-full"><a href="/dashboard" title="Dashbaord">{{ currentClient.name }}</a></div>
            <ul v-else class="dropdown text-14">
                <li>
                    <a class="cursor-pointer">
                        <span>{{ currentClient.name }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8.643" height="8.642" viewBox="0 0 8.643 8.642" class="ml-8">
                            <path d="M8.474,2.828l.465,6.111L2.828,8.474Z" transform="translate(4.321 -4) rotate(45)" fill="#fff"/>
                        </svg>
                    </a>
                    <div>
                        <ul>
                            <li v-for="client in clients" :key="client.id">
                                <span>
                                    <a @click="onSelectClient(client)" class="cursor-pointer">{{ client.name }}</a>
                                    <a v-show="canUpdateClient(client.id)" :href="`/admin/clients/${client.id}/edit`" :title="`${client.name} Settings`" class="cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                            <path id="cog" d="M138.667,136a2.667,2.667,0,1,0-.781,1.885A2.569,2.569,0,0,0,138.667,136ZM144,134.865v2.313a.4.4,0,0,1-.083.24.317.317,0,0,1-.208.135l-1.927.292a6.674,6.674,0,0,1-.406.948q.365.521,1.115,1.438a.4.4,0,0,1,.1.26.348.348,0,0,1-.094.24,10.582,10.582,0,0,1-1.031,1.125q-.75.74-.979.74a.509.509,0,0,1-.271-.094l-1.437-1.125a5.945,5.945,0,0,1-.948.4,17.04,17.04,0,0,1-.3,1.938.351.351,0,0,1-.375.292h-2.312a.394.394,0,0,1-.255-.089.309.309,0,0,1-.12-.224l-.292-1.917a6.438,6.438,0,0,1-.937-.385l-1.469,1.115a.375.375,0,0,1-.26.094.359.359,0,0,1-.26-.115,13.748,13.748,0,0,1-1.719-1.75.407.407,0,0,1-.073-.24.4.4,0,0,1,.083-.24q.156-.219.531-.693t.563-.734a5.154,5.154,0,0,1-.427-1.031l-1.906-.281a.328.328,0,0,1-.219-.13.394.394,0,0,1-.083-.245v-2.312a.4.4,0,0,1,.083-.24.314.314,0,0,1,.2-.135l1.938-.292a5.146,5.146,0,0,1,.406-.958q-.417-.594-1.115-1.437a.391.391,0,0,1-.1-.25.439.439,0,0,1,.094-.24,10.345,10.345,0,0,1,1.026-1.12q.755-.745.984-.745a.444.444,0,0,1,.271.1l1.438,1.115a5.943,5.943,0,0,1,.948-.4,17.036,17.036,0,0,1,.3-1.937.351.351,0,0,1,.375-.292h2.313a.394.394,0,0,1,.255.089.309.309,0,0,1,.12.224l.292,1.917a6.438,6.438,0,0,1,.938.385l1.479-1.115a.338.338,0,0,1,.25-.094.4.4,0,0,1,.26.1,14.25,14.25,0,0,1,1.719,1.771.336.336,0,0,1,.073.229.4.4,0,0,1-.083.24q-.156.219-.531.693t-.562.734a6.275,6.275,0,0,1,.427,1.021l1.906.292a.328.328,0,0,1,.219.13A.394.394,0,0,1,144,134.865Z" transform="translate(-128 -128)"/>
                                        </svg>
                                    </a>
                                </span>
                            </li>
                        </ul>
                        <a v-if="canCreate" href="/admin/clients/create" class="block h-40 leading-40 px-30 bg-pink hover:bg-pink-dark cursor-pointer">+ new client</a>
                    </div>
                </li>
            </ul>
        </div>
    </client-menu>
</template>

<script>
    import { get } from "vuex-pathify"
    import ClientMenu from "./index"
    import ClientMenuMixin from "./mixin"

    export default {
        props: {
            canCreate: {
                type: Boolean,
                default: false
            },
        },

        components: {
            ClientMenu,
        },

        mixins: [ClientMenuMixin],

        computed: {
            clients: get('clients/clients'),
            path() {
                return window.location.pathname
            },
        },

        async mounted() {
            if (this.isLoggedIn) {
                await this.loadClients()
            }
        },
    }
</script>
